import weatherIcons from '../assets/weatherIcons' // The SVGs
// <WeatherIcon forecast={entry} w='20' />


function WeatherIcon(props) {

   const getWeatherIcon = (entry) => {
    const icon = entry.icon
      .replace(',' , '')
      .replace(/[0-9]/g, '')
    const isDaytime = entry.isDaytime

    if (isDaytime) {

      if (icon.includes('day/few')  ||
        icon.includes('day/skc')) return weatherIcons.wi_day_sunny
      if (icon.includes('day/sct') ) return weatherIcons.wi_day_sunny_overcast
      if (icon.includes('day/hot') ) return weatherIcons.wi_hot
      if (icon.includes('day/bkn') ) return weatherIcons.wi_day_cloudy
      if (icon.includes('day/bkn/rain_showers') 
        || icon.includes('day/rain_showers') ) return weatherIcons.wi_day_showers
      if (icon.includes('day/rain') ) return weatherIcons.wi_day_rain
      if (icon.includes('day/snow/sct') ) return weatherIcons.wi_day_rain_mix
      if (icon.includes('day/tsra') ) return weatherIcons.wi_day_storm_showers
      if (icon.includes('day/snow') ) return weatherIcons.wi_day_snow

    }

    if (!isDaytime ) {
    
      if (icon.includes('night/rain_showers') ) return weatherIcons.wi_night_showers
      if (icon.includes('night/few') ) return weatherIcons.wi_night_clear
      if (icon.includes('night/bkn') ) return weatherIcons.wi_night_cloudy
      if (icon.includes('night/sct') ) return weatherIcons.wi_night_cloudy
    }

      
/*


      // Sunny
      if (
        forecast == 'Sunny' ||
        forecast == 'Mostly Sunny'
        ) return weatherIcons.wi_day_sunny



      // Partly Sunny

          if (
            forecast == 'Partly Sunny' ||
            forecast == 'Partly Cloudy'
            ) return weatherIcons.wi_day_cloudy



      // Sun and Rain

      if (
        forecast == 'Partly Sunny then Slight Chance Light Rain' || 
        forecast == 'Partly Sunny then Chance Light Rain' ||
        forecast == 'Partly Sunny then Rain Showers Likely' ||
        forecast == 'Chance Rain Showers then Mostly Sunny' ||
        forecast == 'Partly Sunny then Slight Chance Rain Showers' ||
        forecast == 'Partly Sunny then Chance Rain Showers' ||
        forecast == 'Slight Chance Light Rain then Partly Sunny' ||
        forecast == 'Slight Chance Rain Showers then Mostly Sunny' ||
        forecast == 'Slight Chance Rain Showers then Sunny' ||
        forecast == 'Slight Chance Rain Showers then Partly Sunny' ||
        forecast == 'Mostly Sunny then Slight Chance Rain Showers' 
        ) return weatherIcons.wi_day_showers

      if (
        forecast == 'Partly Sunny then Chance Rain' 
        ) return weatherIcons.wi_day_rain



      // Sun and Snow
      if (
        forecast == 'Mostly Sunny then Isolated Snow Showers' ||
        forecast == 'Slight Chance Snow Showers then Mostly Sunny'
        ) return weatherIcons.wi_day_snow





      // Cloudy

      if (forecast == 'Mostly Cloudy' ) return weatherIcons.wi_cloudy
      

      // Light Rain

      if (
        forecast == 'Mostly Cloudy then Slight Chance Light Rain' ||
        forecast == 'Mostly Cloudy then Light Rain' ||
        forecast == 'Chance Light Rain then Slight Chance Rain Showers' ||
        forecast == 'Mostly Cloudy then Chance Rain Showers' ||
        forecast == 'Chance Light Rain'   ||
        forecast == 'Slight Chance Light Rain' ||
        forecast == 'Light Rain Likely' ||
        forecast ==  'Light Rain Likely then Slight Chance Rain Showers' ||
        forecast ==  'Light Rain Likely then Chance Rain Showers' ||
        forecast == 'Light Rain' ||
        forecast == 'Rain Showers' ||
        forecast == 'Rain Showers Likely' ||
        forecast == 'Chance Rain Showers' ||
        forecast == 'Slight Chance Rain Showers' ||
        forecast == 'Chance Rain Showers then Mostly Cloudy' ||
        forecast == 'Slight Chance Rain Showers then Mostly Cloudy'

        ) return weatherIcons.wi_showers



        // Rain

      if (
        forecast == 'Rain Likely' ||
        forecast == 'Rain' 
        ) return weatherIcons.wi_rain




        // Thunderstorms

      if (
        forecast == 'Showers And Thunderstorms Likely' ||
        forecast == 'Chance Light Rain then Slight Chance T-storms' ||
        forecast == 'Chance Showers And Thunderstorms' ||
        forecast == 'Slight Chance Rain Showers then Slight Chance Showers And Thunderstorms'
        ) return weatherIcons.wi_storm_showers

      if (
        forecast == 'Partly Sunny then Chance Showers And Thunderstorms' ||
        forecast == 'Mostly Sunny then Chance Showers And Thunderstorms'
        ) return weatherIcons.wi_day_storm_showers



        

      // Rain & Snow

      if (
        forecast == 'Chance Rain And Snow' || 
        forecast == 'Chance Snow Showers' ||
        forecast == 'Slight Chance Rain And Snow' ||
        forecast == 'Slight Chance Light Rain then Chance Rain And Snow' ||
        forecast == 'Light Rain Likely then Chance Rain And Snow' ||
        forecast == 'Mostly Cloudy then Slight Chance Rain And Snow' ||
        forecast == 'Slight Chance Snow Showers then Slight Chance Rain Showers'||
        forecast == 'Slight Chance Rain And Snow Showers' ||
        forecast == 'Chance Rain And Snow Showers' ||
        forecast == 'Chance Rain And Snow Showers then Partly Cloudy'

        ) 
      return weatherIcons.wi_rain_mix

      if (
        forecast == 'Slight Chance Rain And Snow Showers then Mostly Sunny'

        ) 
      return weatherIcons.wi_day_rain_mix




   }



  //Night
    if (!isDaytime ) {
      
      if (
        forecast == 'Mostly Clear'
      )  return weatherIcons.wi_night_clear
      if (
        forecast == 'Partly Cloudy'
      )  return weatherIcons.wi_night_alt_cloudy
  
      if (
        forecast == 'Rain Showers Likely' ||
        forecast == 'Light Rain' ||
        forecast == 'Slight Chance Rain Showers' ||
        forecast == 'Slight Chance Rain Showers then Mostly Cloudy'
        ) return weatherIcons.wi_night_showers
  
      if (
        forecast == 'Rain' 
        ) return weatherIcons.wi_night_rain

        
      if (
        forecast == 'Showers And Thunderstorms Likely then Partly Cloudy' 
        ) return weatherIcons.wi_night_storm_showers

          
      if (
        forecast == 'Mostly Cloudy then Chance Snow Showers' 
        ) return weatherIcons.wi_night_snow




    }


 
*/ 

   }

  return (
    <>
     <img className={'w-full h-auto invert'} src={getWeatherIcon(props.entry)} alt='weather icon' />
    </>
  )
}

export default WeatherIcon
